import React, { useState } from 'react';
import useAPI from '../../../../hooks/useAPI';
import { useError } from '../../../../hooks/useErrors';
import FormInput from '../../../FormInput';
import Select from '../../../Select';
import RoundedButton from '../../../RoundedButton';
import countryCodeOptions from '../../../../data/country-codes.json';

export default function SMSAuthSetup () {
    const [countryCode, setCountryCode] = useState('1');
    const [countryCodeError, setCountryCodeError] = useState('');
    const [number, setNumber] = useState('');
    const [numberError, setNumberError] = useState('');
    const [secret, setSecret] = useState('');
    const [secretError, setSecretError] = useState('');
    const [sendingSecret, setSendingSecret] = useState(false);
    const [sendingCode, setSendingCode] = useState(false);
    const [codeSent, setCodeSent] = useState(false);

    const api = useAPI();
    const error = useError();

    const sendCode = () => {
        setSendingCode(true);
        setCountryCodeError('');
        setNumberError('');

        api.json('POST', '/account/two-factor-auth/send-sms-verification', {
            country_code: countryCode,
            number
        })
            .then(r => r.json())
            .then((r) => {
                if (r.errors) {
                    if (r.errors.country_code) {
                        setCountryCodeError(r.errors.country_code[0]);
                    }
                    if (r.errors.number) {
                        setNumberError(r.errors.number[0]);
                    }
                    return;
                }
                setCodeSent(r.success || false);
            })
            .catch((e) => error(e))
            .finally(() => setSendingCode(false));
    };

    const sendSecret = () => {
        setSendingSecret(true);

        api.json('POST', '/account/two-factor-auth/sms-setup', {
            secret
        })
            .then(r => r.json())
            .then((r) => {
                if (r.errors) {
                    if (r.errors.secret) {
                        setSecretError(r.errors.secret[0]);
                    }
                    return;
                }

                if (!r.success) {
                    setSecretError('Invalid code');
                    return;
                }

                const auth = api.cookie('auth');
                auth.two_factor_auth_enabled = true;
                auth.two_factor_auth_type = r.two_factor_auth_type;
                api.cookie('auth', auth);
                window.location.reload(true);
            })
            .catch(e => error(e))
            .finally(() => setSendingSecret(false));
    };

    return (
        <>
            {!codeSent ?
                <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <Select
                        label="Country Code"
                        value={countryCode}
                        options={countryCodeOptions.map((cc) => ({
                            label: `${cc.label} (+${cc.value})`,
                            value: cc.value
                        }))}
                        onChange={(e) => setCountryCode(e.target.value)}
                        error={countryCodeError}
                    />
                    <FormInput
                        label="Phone Number"
                        value={number}
                        disabled={sendingCode}
                        maxLength="10"
                        placeholder="Enter Phone Number"
                        onChange={(e) => setNumber((e.target.value + '').replace(/[^0-9]+/g, ''))}
                        error={numberError}
                    />
                    <span style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', marginBottom: 16 }}>
                        <RoundedButton
                            disabled={number.length < 10 || sendingCode}
                            onClick={sendCode}
                        >
                            Send Code
                        </RoundedButton>
                    </span>
                </div>
                :
                <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
                    <div>
                        <div className='row'>
                            <div className='col-12'>
                                <FormInput
                                    value={secret}
                                    disabled={sendingSecret}
                                    maxLength="6"
                                    placeholder="Enter Code"
                                    onChange={(e) => setSecret((e.target.value + '').replace(/[^0-9]+/g, ''))}
                                    error={secretError}
                                />
                            </div>
                            <div className='col-12'>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 12 }}>
                                    {/* eslint-disable-next-line */}
                                    <a href="#" onClick={(e)=>{
                                        e.preventDefault();
                                        setCodeSent(false);
                                        setNumber('');
                                        setNumberError('');
                                        setSecret('');
                                        setSecretError('');
                                    }}>Re-enter phone number.</a>
                                </div> 
                            </div>
                        </div>
                    </div>

                    <span>
                        <RoundedButton
                            disabled={secret.length < 6 || sendingSecret}
                            onClick={sendSecret}
                            solid
                        >
                            Submit
                        </RoundedButton>
                    </span>
                </div>
            }
        </>
    );
};